module.exports = __webpack_public_path__ + "img/logo.dcd4818d.svg";